import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-container-field-taxonomies',
  templateUrl: './container-field-taxonomies.component.html',
  styleUrls: ['./container-field-taxonomies.component.scss']
})
export class ContainerFieldTaxonomiesComponent implements OnInit {

  @Input() dataFieldTaxonomies: any[] = [];
  @Input() typeOfContent: string = '';
  @Input() hour: string = '';
  public singleColumn: boolean = false;
  public dataFieldTaxonomiesView = [];

  constructor() { }

  ngOnInit(): void {
    if (this.dataFieldTaxonomies && this.dataFieldTaxonomies.length) {
      for (let dataFieldTaxonomy of this.dataFieldTaxonomies) {
        if (dataFieldTaxonomy.value && dataFieldTaxonomy.value.length && dataFieldTaxonomy.isArray) {
          let i = 0;
          for (let data of dataFieldTaxonomy.value) {
            i++;
            data.displayName = this.getDisplayName(data);
            if (i !== dataFieldTaxonomy.value.length) {
              data.displayName = this.getDisplayName(data) + ',';
            }
          }
        }
      }
    }
  }

  getDisplayName(data: any): string {
    if (data.nome_frontend) {
      return data.nome_frontend;
    } else if (data.field_nome_frontend) {
      return data.field_nome_frontend;
    } else if (data.name) {
      return data.name;
    } else {
      return data.value;
    }
  }

}
